import { Injectable } from '@angular/core';
import {GenericService} from "../../commons/generic.service";
import {environment} from "../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs/internal/Observable";
import {DependentesServidorDto} from "../../components/recadastramento-aba7/dependentesServidor.dto";
import {TipoParentescoDto} from "../../model/tipoParentesco.dto";
import {ArquivoBlobDTO} from "../../model/arquivoBlob.dto";

@Injectable({
  providedIn: 'root'
})
export class DependentesServidorAba7Service extends GenericService {

  private basePath = 'api/v1';
  private path = '/dependentes';
  url = environment.url;

  constructor(http: HttpClient) {
    super(http);
  }

  getDependentes(): Observable<DependentesServidorDto[]> {
    return this.http.get<DependentesServidorDto[]>(this.url + this.basePath + this.path);
  }

  getTipoParentescos(): Observable<TipoParentescoDto[]> {
    return this.http.get<TipoParentescoDto[]>(this.url + this.basePath + '/tipo-parentesco');
  }

  getArquivos(idRecadDependente: string, tipo: string): Observable<ArquivoBlobDTO> {
    const options = {
      responseType: 'blob' as 'json'
    };
    return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + '/dependentes-visualizar/' + tipo +'/' + idRecadDependente, options);
  }

  uploadComprovante(file: File, numeDependente: string, tipoDocumento: string) {
    const formData = new FormData();
    formData.append('documento', file);
    formData.append('numeDependente', numeDependente);

    return this.postMethodFile(this.basePath + '/dependentes-upload/'+ tipoDocumento, formData);
  }

  salvarDependentes(data): Observable<any> {
    return this.http.post(this.url + this.basePath + this.path + "/salvar", data);
  }

}
